export default class Review {
  constructor() {
    this.taxBracket = true;
  }

  loadData(payload) {
    if (payload.Personal_Info) {
      this.taxBracket = payload.Personal_Info.Federal_Tax_Bracket;
    }
  }
}
